import { createReducer } from 'deox';
import { ApiDoc, Paging } from '@/types';
import {
  fetchApiDocsActions,
  voteApiDocActions,
  searchApiDocsActions,
  fetchApiDocActions,
  apiDocActions,
  fetchApiGroupsActions,
} from '../actions/api-docs';

export interface ApiDocsState {
  groups: string[];
  apiDocs: {
    data: ApiDoc[];
    paging: Paging;
  };
  apiDoc?: ApiDoc;
  searchApis: {
    groups: string[];
    apiDocs: ApiDoc[];
    totalRecords: number;
  };
}

const initialState: ApiDocsState = {
  groups: [],
  apiDocs: {
    data: [],
    paging: {
      pageNumber: 1,
      pageSize: 5,
      totalRecords: 0,
    },
  },
  apiDoc: undefined,
  searchApis: {
    groups: [],
    apiDocs: [],
    totalRecords: 0,
  },
};

const apiDocsReducer = createReducer(initialState, (handleAction) => [
  handleAction(searchApiDocsActions.success, (state, { payload }) => ({
    ...state,
    searchApis: payload,
  })),
  handleAction(fetchApiDocsActions.success, (state, { payload }) => {
    return {
      ...state,
      apiDocs: payload,
    };
  }),
  handleAction(fetchApiGroupsActions.success, (state, { payload }) => {
    return {
      ...state,
      groups: payload.data,
    };
  }),
  handleAction(apiDocActions.clearSwagger, (state, { payload }) => ({
    ...state,
    data: state.apiDocs.data.filter((api) => {
      if (api.id === payload.apiId) {
        return { ...payload, swagger: '' };
      }
      return { ...api };
    }),
    apiDoc: undefined,
  })),
  handleAction(fetchApiDocActions.success, (state, { payload }) => ({
    ...state,
    data: state.apiDocs.data.map((api) => {
      if (api.id === payload.api.id) {
        return { ...payload.api };
      }
      return { ...api };
    }),
    apiDoc: payload.api,
  })),
  handleAction(voteApiDocActions.success, (state, { payload }) => ({
    ...state,
    data: state.apiDocs.data.map((doc) => {
      if (doc.id === payload.id) {
        return { ...doc, votes: doc.votes + 1 };
      }
      return { ...doc };
    }),
  })),
]);

export default apiDocsReducer;
